import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import type { ArtifactReference } from './ArtifactCard';

import { useTranslation } from 'react-i18next';
interface UpgradeCTACardProps {
  artifact: ArtifactReference;
}

export default function UpgradeCTACard({ artifact }: UpgradeCTACardProps) {
  const { t } = useTranslation('chat');
  const navigate = useNavigate();

  return (
    <div className="mt-2 p-3 rounded-[12px] border border-[var(--error-outline,#ff9196)] bg-[#fff8f8]">
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 text-[var(--error-outline,#ff9196)] flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="font-manrope font-semibold text-[13px] leading-[18px] text-[color:var(--black-text,#0d0d0d)]">
            {t('upgradeCTA.title')}
          </p>
          <p className="font-segoe text-[12px] leading-[16px] text-[color:var(--grey-text,#565858)] mt-0.5">
            {artifact.summary || t('upgradeCTA.defaultDescription')}
          </p>
        </div>
        <button
          className="flex-shrink-0 px-[12px] py-[4px] rounded-[8px] bg-[var(--main-brand,#2197f1)] text-white font-manrope font-semibold text-[12px] leading-[16px] hover:opacity-90 transition-opacity"
          onClick={(e) => {
            e.stopPropagation();
            navigate('/subscription');
          }}
        >
          {t('upgradeCTA.button')}
        </button>
      </div>
    </div>
  );
}
